import { render, staticRenderFns } from "./richTextDetails.vue?vue&type=template&id=4f62ce51&scoped=true&"
import script from "./richTextDetails.vue?vue&type=script&lang=js&"
export * from "./richTextDetails.vue?vue&type=script&lang=js&"
import style0 from "./richTextDetails.vue?vue&type=style&index=0&id=4f62ce51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f62ce51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f62ce51')) {
      api.createRecord('4f62ce51', component.options)
    } else {
      api.reload('4f62ce51', component.options)
    }
    module.hot.accept("./richTextDetails.vue?vue&type=template&id=4f62ce51&scoped=true&", function () {
      api.rerender('4f62ce51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/announcement/components/richTextDetails.vue"
export default component.exports